// weekDates.js — Cálculo de datas dos 7 dias da semana temática.
// Timezone: America/Recife (UTC-3, sem DST).
//
// Entrada: week_start = "YYYY-MM-DD" (data do dia 1)
// Saída: array de 7 objetos { day, iso, dayNum, monthNum, weekdayPt, isToday }

const WEEKDAY_PT = [
  "domingo",
  "segunda-feira",
  "terça-feira",
  "quarta-feira",
  "quinta-feira",
  "sexta-feira",
  "sábado",
];

const MONTH_PT = [
  "janeiro", "fevereiro", "março", "abril", "maio", "junho",
  "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
];

/**
 * Retorna a data "hoje" em America/Recife como {y, m, d} (números).
 * Timezone: America/Recife = UTC-3 fixo (sem DST).
 */
function todayInRecife() {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const recife = new Date(utc - 3 * 60 * 60 * 1000);
  return {
    y: recife.getUTCFullYear(),
    m: recife.getUTCMonth() + 1,
    d: recife.getUTCDate(),
    iso: `${recife.getUTCFullYear()}-${String(recife.getUTCMonth() + 1).padStart(2, "0")}-${String(recife.getUTCDate()).padStart(2, "0")}`,
  };
}

/**
 * Parseia "YYYY-MM-DD" em componentes numéricos (sem alterar timezone).
 */
function parseIso(iso) {
  if (!iso || typeof iso !== "string") return null;
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  return { y: Number(m[1]), mo: Number(m[2]), d: Number(m[3]) };
}

/**
 * Adiciona N dias a uma data {y, mo, d} sem depender do timezone local.
 * Usa Date UTC internamente para não pular DST.
 */
function addDays({ y, mo, d }, n) {
  const dt = new Date(Date.UTC(y, mo - 1, d));
  dt.setUTCDate(dt.getUTCDate() + n);
  return {
    y: dt.getUTCFullYear(),
    mo: dt.getUTCMonth() + 1,
    d: dt.getUTCDate(),
    weekday: dt.getUTCDay(), // 0..6, domingo = 0
  };
}

/**
 * Formata "DIA N · SEGUNDA-FEIRA, 19 DE JULHO"
 */
function formatHeader(dayNum, dateInfo) {
  const weekday = WEEKDAY_PT[dateInfo.weekday] || "";
  const month = MONTH_PT[dateInfo.mo - 1] || "";
  return `Dia ${dayNum} · ${weekday}, ${dateInfo.d} de ${month}`;
}

/**
 * Gera os 7 dias a partir do week_start.
 * Retorna [] se week_start inválido.
 */
export function computeWeekDates(weekStartIso) {
  const parsed = parseIso(weekStartIso);
  if (!parsed) return [];
  const today = todayInRecife();
  const days = [];
  for (let i = 0; i < 7; i++) {
    const d = addDays({ y: parsed.y, mo: parsed.mo, d: parsed.d }, i);
    const iso = `${d.y}-${String(d.mo).padStart(2, "0")}-${String(d.d).padStart(2, "0")}`;
    const isToday = iso === today.iso;
    const isPast = iso < today.iso;
    days.push({
      day: i + 1,
      iso,
      dayNum: d.d,
      monthNum: d.mo,
      weekdayIdx: d.weekday,
      weekdayPt: WEEKDAY_PT[d.weekday] || "",
      monthPt: MONTH_PT[d.mo - 1] || "",
      header: formatHeader(i + 1, d),
      isToday,
      isPast,
    });
  }
  return days;
}
